// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tournaments-list_App__aLTsh {
    display: flex;
    flex-direction: column;
    gap: 2px;
    width: 80%;
    min-height: 0px;
    flex: 1 1;

    overflow-y: auto;
}

.tournaments-list_Tournament__sR0Tb {
    display: flex;
    justify-content: space-between;
    align-items: center;

    width: 100%;
    height: 50px;
    padding: 10px;

    border-radius: 6px;
    background-color: white;

    font-family: "Roboto","Helvetica","Arial",sans-serif;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.87);

    >div {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: start;

        >div {
            display: flex;
            gap: 10px;
        }
    }
}

@media (max-width: 768px) {
    .tournaments-list_App__aLTsh {
        width: 100%;
    }
}
`, "",{"version":3,"sources":["webpack://./src/pages/TournamentsListPageN/ui/tournaments-list.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,UAAU;IACV,eAAe;IACf,SAAO;;IAEP,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;;IAEnB,WAAW;IACX,YAAY;IACZ,aAAa;;IAEb,kBAAkB;IAClB,uBAAuB;;IAEvB,oDAAoD;IACpD,gBAAgB;IAChB,0BAA0B;;IAE1B;QACI,aAAa;QACb,sBAAsB;QACtB,uBAAuB;QACvB,kBAAkB;;QAElB;YACI,aAAa;YACb,SAAS;QACb;IACJ;AACJ;;AAEA;IACI;QACI,WAAW;IACf;AACJ","sourcesContent":[".App {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n    width: 80%;\n    min-height: 0px;\n    flex: 1;\n\n    overflow-y: auto;\n}\n\n.Tournament {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n\n    width: 100%;\n    height: 50px;\n    padding: 10px;\n\n    border-radius: 6px;\n    background-color: white;\n\n    font-family: \"Roboto\",\"Helvetica\",\"Arial\",sans-serif;\n    font-weight: 400;\n    color: rgba(0, 0, 0, 0.87);\n\n    >div {\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        align-items: start;\n\n        >div {\n            display: flex;\n            gap: 10px;\n        }\n    }\n}\n\n@media (max-width: 768px) {\n    .App {\n        width: 100%;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"App": `tournaments-list_App__aLTsh`,
	"Tournament": `tournaments-list_Tournament__sR0Tb`
};
export default ___CSS_LOADER_EXPORT___;
